export const PortalRoutes = {
  // home
  HOME: "/",
  STATUS_INDICATOR: "/farol",

  // pasture management
  PASTURE_REGISTRATIONS: "/cadastro",
  EDIT_PASTURE: "/cadastro_editar_pasto",
  NEW_PASTURE: "/cadastro_novo_pasto",
  NEW_FARM: "/cadastro_nova_fazenda",
  RETREAT_REGISTRATIONS: "/cadastro_retiro",
  MODULE_LINKAGE: "/vinculo",

  // login
  LOGIN: "/login",
  FORGOT_PASSWORD: "/esqueceu-senha",
  CHANGE_PASSWORD: "/alterar-senha/:token",

  // analytics
  ANALYTICS: "/analytics",

  // configurations
  CONFIGURATIONS_EDIT_FORMULATION: "/configuracoes/cadastros/edicao-formulacao",
  CONFIGURATIONS_REGISTRATIONS: "/configuracoes/cadastros",
  CONFIGURATIONS: "/configuracoes",

  // collects
  COLLECTS: "/coletas",

  // consumption closure
  CONSUMPTION_CLOSURE: "/fechamento_consumo",

  // herd control
  HERD_CONTROL: "/controleDeRebanho",

  // user management
  CREATE_NEW_USER: "/gestao-de-usuarios/cadastrar",
  EDIT_USER: "/gestao-de-usuarios/editar/:idUsuario",
  USER_MANAGEMENT: "/gestao-de-usuarios",

  // pending movements
  PENDING_MOVEMENTS: "/movimentacoesPendentes",

  // collects
  COLLECT_SUPPLEMENTATION: "/coletas/suplementacao",

  // supplementation
  SUPPLEMENTATION: "/suplementacao",

  // app movement history
  APP_MOVEMENT_HISTORY: "/historico_movimentacao_aplicativo",
} as const;

export type Routes = (typeof PortalRoutes)[keyof typeof PortalRoutes];
